/* eslint-disable no-unused-vars */
import { Box, Button, Typography } from "@mui/material";
import { LayoutOnboarding, LoadingBackdrop } from "../../../../components";
import { PAGES_PATH, STEP_NAME_PATH } from "../../../../navigation/params";
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { LoginForm } from "../../forms";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import ToggleButton from "../../../../components/ToggleButton/ToggleButton";
import { useOtpSignUp } from "../../../../services/user/user-otp.service";
import { useStepNavigation } from "../../../../hooks";
import { useUserStatusStore } from "../../../../hooks/redux-hooks/user-status/user-status.store";
import { userActivityLogger } from "../../../../utils/mixpanel";

const LoginContainer: React.FC = () => {
  const LOGIN_METHODS = [{ displayText: "Email", value: "email" }, { displayText: "Mobile", value: "mobile" }];
  const { setNext } = useStepNavigation();
  const goToContinue = () => setNext(PAGES_PATH.OTP_VERIFICATION);
  const { setEmailSignIn, setPhoneSignIn } = useUserStatusStore();
  const [loginMethod, setLoginMethod] = useState<string>(LOGIN_METHODS[0].value);
  const { sendOTP, data, error, loading } = useOtpSignUp();
  const [searchParams] = useSearchParams();
  const [phoneOrEmail, setPhoneOrEMail]=useState<string>("");

  const token = searchParams.get("testingToken");

  const navigate = useNavigate();

  type LoginData = { email: string } | { phone: string };

  const handleChange = (loginMethod: string) => {
    setLoginMethod(loginMethod);
  };

  const handleSendOTP = (data: LoginData) =>{
    if ("email" in data) {
      setEmailSignIn(data.email);
      setPhoneOrEMail(data.email);
      setPhoneSignIn("");
    } else if ("phone" in data) {
      setPhoneSignIn(data.phone);
      setPhoneOrEMail(data.phone);
      setEmailSignIn("");
    }
    if (token && loginMethod === "mobile" && process.env.REACT_APP_NODE_ENV !== "production") {
      const updatedData = { ...data, testingToken: token };

      sendOTP(updatedData);
    } else {
      if ("phone" in data) {
        userActivityLogger(MIXPANEL_EVENTS.USER_REQUEST_OTP,
          { signin_type: "mobile", user_type: "existing_user" },
          { phone: data?.phone });
      } else if ("email" in data) {
        userActivityLogger(MIXPANEL_EVENTS.USER_REQUEST_OTP,
          { signin_type: "email", user_type: "existing_user" },
          { email: data.email });
      }
      sendOTP(data);
    }
  };

  // Mixpanel event logger
  useEffect(() => {
    if (data) {
      goToContinue();
    }
  }, [data, error]);

  return (
    <>
      {loading &&
          <LoadingBackdrop />
      }
      <LayoutOnboarding image="/assets/icons/welcome_screen.jpg">
        <Box className="flex flex-col items-center w-full h-full gap-4">
          <Typography variant="h1" className="!font-bold">Log In</Typography>
          <Typography sx={{ mb: 1 }} className="flex !text-base">
            Don&apos;t have an account?
            <span
              className="!ms-2 text-mustard !text-base cursor-pointer font-semibold"
              onClick={()=>navigate(`${PAGES_PATH.SIGN_UP}`)}
            >
              Create Account
            </span>
          </Typography>
          <Box className="flex flex-col justify-center items-center gap-8 w-full">
            <ToggleButton
              handleOnClick={handleChange}
              selectedButton={loginMethod}
              buttonList={LOGIN_METHODS}
            />
            <Box sx={{ width: "100%" }}>
              <LoginForm loginMethod={loginMethod} handleSendOTP={handleSendOTP}/>
            </Box>
          </Box>
        </Box>
      </LayoutOnboarding>
    </>
  );
};

export default LoginContainer;
